export default "__VITE_ASSET__adbaa4a0__"